import { getStatus, RunState } from "@/store/flowsheet/flowsheet.slice"
import { Radio } from "antd"
import classNames from "classnames"
import { useSelector } from "react-redux"

interface SpecialConditionProps {
  value?: string
  disabled?: boolean
  onChange?: (val: string| undefined) => void
  className?: string
}

export const SpecialCondition = (props: SpecialConditionProps) => {
  const { value, disabled, className, onChange } = props
  const status = useSelector(getStatus)

  return <div className={classNames(className)}>
    <div style={{width: 120}}>Special Condition:</div>
    <div className="mt-1">
      <Radio.Group value={value} disabled={disabled || status === RunState.Stop} onChange={(e) => onChange?.(e.target.value)}>
        <Radio value={undefined}>None</Radio>
        <Radio value={'DEW'}>Dew Point</Radio>
        <Radio value={'BOIL'}>Boiling Point</Radio>
      </Radio.Group>
    </div>
    
  </div>
}